'use strict';

var e={contentDivider:"contentDivider",tertiary:"tertiary"},t={center:"center",left:"left"};

exports.a = e;
exports.b = t;
